export default dictionaryToTwoDimensionalArray =>
    Object.keys(dictionaryToTwoDimensionalArray).reduce((acc, cur) => {
        acc.push([cur, dictionaryToTwoDimensionalArray[cur]]);
        return acc;
    }, []);
